import { Pipe, PipeTransform } from '@angular/core';
import { getActivityDescription } from './activity.functions';

@Pipe({
  name: 'activityDescription'
})
export class ActivityDescriptionPipe implements PipeTransform {
    transform(activity?: any): string {
        return getActivityDescription(activity);
    }
};